import { Box, Button, Grid, Typography, styled, useTheme } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import { TransferData } from "assets/Icon";
import useIsMobileView from "hooks/useIsMobileView";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

function FormHeader({
  setShowMarketDrawer,
}) {
  const theme = useTheme();
  const isMobileView = useIsMobileView();
  const { watch } = useFormContext();

  const tradeInsertForm = useSelector(
    (state) => state.trade?.tradeInsertForm?.data
  );

  const { source, destination } = useParams();
  const basketId = watch("basketId");

  const coinSelected = useMemo(() => {
    const coin = tradeInsertForm?.lisCoinPair.find(
      (item) =>
        item.basketId === basketId &&
        item.coinDestinationId === +destination &&
        item.coinSourceId === +source
    );
    return coin;
  }, [basketId, destination, source, tradeInsertForm?.lisCoinPair]);

  return (
    <Grid container mb={1}>
      <Grid item xs={4}>
        <ButtonStyle size="small" onClick={() => setShowMarketDrawer(true)}>
          <TransferData color={theme.palette.text.main} />
          <CoinImageWrapper ml={1}>
            <img
              className="behind-img"
              src={DefaultUrlWeb + coinSelected?.coinDestinationImageUrl}
              alt=""
            />

            <img
              className="front-img"
              src={DefaultUrlWeb + coinSelected?.coinSourceImageUrl}
              alt=""
            />
          </CoinImageWrapper>
        </ButtonStyle>
      </Grid>

      <Grid item xs={8} textAlign="right">
        <Box textAlign="center">
          <Typography variant={isMobileView ? "h6" : "h4"} color="text.main">
            {coinSelected?.coinSourceName}/
            <Typography variant={isMobileView ? "h6" : "h5"} component="small">
              {coinSelected?.coinDestinationName}
            </Typography>
          </Typography>

          <Typography variant={isMobileView ? "h6" : "h5"} color="text.main">
            {coinSelected?.coinSourceCoinName}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

const CoinImageWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100%",
  minHeight: "45px",

  ".behind-img": {
    top: "0",
    left: "15px",
    position: "absolute",
    borderRadius: "50%",
    width: "27px",
  },
  ".front-img": {
    top: "10px",
    position: "absolute",
    borderRadius: "50%",
    width: "30px",
  },
}));

const ButtonStyle = styled(Button)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "transparent !important",
  },
}));

export default FormHeader;
